import {ListViewProvider} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {JobTable} from './table/JobTable'
import {KTCard} from '../../../../../_metronic/helpers'
import {PageTitle} from '../../../../../_metronic/layout/core'

// const breadcrumbs: Array<PageLink> = [
//   {
//     title: 'Home',
//     path: '/dashboard',
//     isSeparator: false,
//     isActive: false,
//   },
//   {
//     title: '',
//     path: '',
//     isSeparator: true,
//     isActive: false,
//   },
// ]

const JobList = () => {
  return (
    <KTCard>
      <JobTable />
    </KTCard>
  )
}

const JobListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>

        {/* ✅ Page title MUST be here */}
        <PageTitle>Jobs list</PageTitle>

        {/* ✅ Page content */}
        <JobList />

      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {JobListWrapper}
